import { compose, pure } from 'recompose';

import BannerRequestNotification from './bannerRequestNotification';

const enhance = compose(
  pure,
);

export default enhance(BannerRequestNotification);
